export const apiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  return (
    data?.message ||
    data?.error ||
    data?.errors?.[0]?.message ||
    fallback ||
    error?.message
  );
};

export const addMemberErrorMessage = (error, t, fallback) => {
  const serverMessage = error?.response?.data?.message;
  if (
    error?.response?.status === 422 &&
    /already in this list/i.test(serverMessage || '')
  ) {
    return t('LISTS_PAGE.ALREADY_IN_LIST');
  }
  return apiErrorMessage(error, fallback);
};

export const skippedMemberMessage = (result, t) => {
  switch (result?.skipped) {
    case 'already_member':
      return t('LISTS_PAGE.ALREADY_IN_LIST');
    case 'blocked':
      return t('LISTS_PAGE.MEMBERS.BLOCKED_NOT_ADDED');
    default:
      return null;
  }
};
